import React from 'react';
import { offerAnchor, protocolStructure, sampleMeta, sampleTimeline } from '../data/content';
import { Button } from './ui/Button';
import { Eyebrow, Mark, SectionTitle } from './ui/Section';
export function LookInside() {
  return <section className="bg-slate-50 px-4 py-12 md:py-16" data-id="element-118" data-mp="21mhff462dlfw">
      <div className="mx-auto max-w-3xl" data-id="element-119" data-mp="25o303boub40n">
        <Eyebrow data-id="element-120" data-mp="25n1dc9ygot33">Look inside</Eyebrow>
        <SectionTitle data-id="element-121" data-mp="1rx7q1w2lugvh">
          See how a complete sports massage <Mark data-id="element-122" data-mp="1rvmuq48gutwk">session is organized</Mark>
        </SectionTitle>
        <p className="mx-auto mt-4 max-w-2xl text-center text-sm leading-relaxed text-slate-600 md:text-base" data-id="element-123" data-mp="1wo7k8tkcakua">
          Instead of giving you only the name of a technique, the system helps you see how the selected techniques fit
          into a practical professional session.
        </p>

        <article className="mt-8 overflow-hidden rounded-2xl border border-blue-950/10 bg-white shadow-xl" data-id="element-124" data-mp="18xtqmym3wdxl">
          <header className="bg-blue-950 p-5" data-id="element-125" data-mp="1dxptuvmzc1c3">
            <p className="text-[10px] font-extrabold uppercase tracking-wider text-sky-300" data-id="element-126" data-mp="1dzj22fd8qtm7">Example session</p>
            <h3 className="mt-1 text-base font-black uppercase text-white md:text-lg" data-id="element-127" data-mp="a4isiduhw9p6">
              Running — 30-Minute Lower Body Session
            </h3>
            <p className="mt-2 text-xs leading-relaxed text-white/70" data-id="element-128" data-mp="jzj2l8gafzum">
              Illustrative session example for an appropriately assessed adult client requesting posterior-thigh and
              calf massage.
            </p>
          </header>
          <dl className="grid grid-cols-2 gap-px bg-blue-950/10 sm:grid-cols-3" data-id="element-129" data-mp="3iihmj9xwpl01">
            {sampleMeta.map(([label, value]) => <div key={label} className="bg-white p-4" data-id="element-130" data-mp="129kbump8sey">
                <dt className="text-[10px] font-extrabold uppercase tracking-wider text-slate-600" data-id="element-131" data-mp="13t0zmc9p5h9">{label}</dt>
                <dd className="mt-0.5 text-sm font-bold text-blue-950" data-id="element-132" data-mp="34r2ygop56tm4">{value}</dd>
              </div>)}
          </dl>
          <div className="border-t border-blue-950/10 px-5 pt-4" data-id="element-133" data-mp="2zqyjj33vu6y0">
            <p className="text-[11px] font-black uppercase tracking-wider text-blue-700" data-id="element-134" data-mp="13ov886cnb3ck">Example session timeline</p>
            <table className="mt-2 w-full text-left text-sm" data-id="element-135" data-mp="18neq9vo4buzn">
              <thead className="sr-only" data-id="element-136" data-mp="18llk0hhf3cs6">
                <tr data-id="element-137" data-mp="1deeqb9sjat6d">
                  <th scope="col" data-id="element-138" data-mp="1dfy4muumqu5i">Stage</th>
                  <th scope="col" data-id="element-139" data-mp="1hg8mb4rsb907">Time</th>
                </tr>
              </thead>
              <tbody data-id="element-140" data-mp="1hiclxainhluo">
                {sampleTimeline.map(([stage, time]) => <tr key={stage} className="border-b border-blue-950/10" data-id="element-141" data-mp="krty6748id1r">
                    <th scope="row" className="py-2.5 pr-3 align-top font-semibold text-blue-950" data-id="element-142" data-mp="pq3sygm1rbmu">
                      {stage}
                    </th>
                    <td className="whitespace-nowrap py-2.5 text-right font-bold tabular-nums text-blue-700" data-id="element-143" data-mp="ypqwb7yc6rij">{time}</td>
                  </tr>)}
                <tr data-id="element-144" data-mp="255b1m5yy4prj">
                  <th scope="row" className="py-3 pr-3 text-xs font-black uppercase tracking-wider text-blue-950" data-id="element-145" data-mp="257x802a3oz86">
                    Total
                  </th>
                  <td className="whitespace-nowrap py-3 text-right font-black tabular-nums text-blue-950" data-id="element-146" data-mp="2k7j7toxf9kxf">30 min</td>
                </tr>
              </tbody>
            </table>
            <p className="pb-4 text-xs italic leading-relaxed text-slate-600" data-id="element-147" data-mp="2aij9m7qqutka">
              Actual treatment selection and timing must be adjusted to the client's needs, consent, response, and the
              therapist's professional judgment.
            </p>
          </div>
          <div className="border-t border-blue-950/10 bg-slate-50 px-5 py-4" data-id="element-148" data-mp="1wj9tt96ga1gu">
            <p className="text-[11px] font-black uppercase tracking-wider text-blue-950" data-id="element-149" data-mp="1wlcnq4aq4equ">
              Each practical protocol may include:
            </p>
            <ul className="mt-2 flex flex-wrap gap-1.5" data-id="element-150" data-mp="1njmzf7c51vxa">
              {protocolStructure.map(item => <li key={item} className="rounded-md border border-blue-950/10 bg-white px-2 py-1 text-[10px] font-bold uppercase tracking-wide text-slate-700" data-id="element-151" data-mp="3lwwt70egsmui">
                  {item}
                </li>)}
            </ul>
          </div>
        </article>

        <div className="mt-10 text-center" data-id="element-152" data-mp="3twtaik2y39dj">
          <p className="text-sm font-black uppercase tracking-wide text-blue-950 md:text-base" data-id="element-153" data-mp="3fznzs6sadmby">
            Imagine opening every appointment with your session already planned.
          </p>
          <div className="mt-4" data-id="element-154" data-mp="368t9mrbx62l8">
            <Button href={offerAnchor} size="lg" subtext="See everything included + today's launch price" data-id="element-155" data-mp="368jj92myptf0">
              I want my sessions organized
            </Button>
          </div>
        </div>
      </div>
    </section>;
}